import { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

import { ImageBox } from "./ImageBox";

type Testimonial = {
  quote: string;
  name: string;
  role: string;
};

const learnerTestimonials: Testimonial[] = [
  {
    quote: "You’ve helped me sooo much 🥺❤️ already I got 85% for my paper 2 English and all I did was watch your videos thanks alot.",
    name: "A.E Smada",
    role: "Learner",
  },
  {
    quote: "Simple and effective. I didn’t feel overwhelmed and I received explanations to my answers. Very happy with this!!",
    name: "Hudaa_",
    role: "Learner",
  },
  {
    quote: "Explained so well. Thank you! ❤️",
    name: "claire_",
    role: "Learner",
  },
];

const teacherTestimonials: Testimonial[] = [
  {
    quote: "I love the content, makes it easier for the student to learn. I wish you could have tutorials for each subject, like, Maths and History for Grade 12.",
    name: "Mr.Dudley",
    role: "Teacher",
  },
  {
    quote: "Excellent work! This is Brilliant!",
    name: "Mr. Charles",
    role: "Teacher",
  },
];

const allTestimonials: Testimonial[] = [
  ...learnerTestimonials,
  ...teacherTestimonials,
];

export function Testimonials() {
  const [start, setStart] = useState(0);
  const visible = [0, 1, 2].map((i) => (start + i) % allTestimonials.length);

  return (
    <div>
      <div className="flex items-center gap-4">
        <button
          type="button"
          aria-label="Previous"
          onClick={() => setStart((s) => (s - 1 + allTestimonials.length) % allTestimonials.length)}
          className="hidden size-11 shrink-0 items-center justify-center rounded-full border border-ink-foreground/25 text-ink-foreground transition-colors hover:border-primary hover:text-primary-on-ink md:flex"
        >
          <ChevronLeft className="size-5" />
        </button>

        <div className="grid flex-1 gap-6 md:grid-cols-3">
          {visible.map((i) => {
            const item = allTestimonials[i]!;
            return (
              <figure key={i} className="rounded-2xl bg-card p-7 text-center shadow-[var(--shadow-card)]">
                <Quote className="mx-auto size-8 fill-primary text-primary-strong" />
                <blockquote className="mt-5 text-sm leading-relaxed text-muted-foreground">
                  {item.quote}
                </blockquote>
                
                <figcaption className="mt-4">
                  <div className="font-display text-base font-bold text-card-foreground">{item.name}</div>
                  <div className="text-xs text-muted-foreground">{item.role}</div>
                </figcaption>
              </figure>
            );
          })}
        </div>

        <button
          type="button"
          aria-label="Next"
          onClick={() => setStart((s) => (s + 1) % allTestimonials.length)}
          className="hidden size-11 shrink-0 items-center justify-center rounded-full border border-ink-foreground/25 text-ink-foreground transition-colors hover:border-primary hover:text-primary-on-ink md:flex"
        >
          <ChevronRight className="size-5" />
        </button>
      </div>

      <div className="mt-8 flex flex-wrap justify-center gap-1">
        {allTestimonials.map((_, i) => (
          <button
            key={i}
            type="button"
            aria-current={i === start ? "true" : undefined}
            aria-label={`Testimonial ${i + 1} of ${allTestimonials.length}`}
            onClick={() => setStart(i)}
            className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full"
          >
            <span
              aria-hidden="true"
              className={`block size-2.5 rounded-full transition-colors ${i === start ? "bg-primary" : "bg-ink-foreground/25"}`}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
